import { Component, EventEmitter, Input, Output } from "@angular/core";
import { HasId } from "app/shared/model/properties.model";
import { EntityPager } from "./entity-pager.model";

@Component({
	templateUrl: './entity-pager.component.html',
	styleUrls: ['./entity-pager.component.scss'],
	selector: 'lb-entity-pager[src]'
})
export class EntityPagerComponent {
	@Input() src!: EntityPager<HasId>;
	@Output() backToListClicked = new EventEmitter();

	get isLoading() {
		return this.src.isLoading;
	}

	getNext(direction: 'FORWARD' | 'BACKWARD') {
		this.src.getNextItem(direction).subscribe();
	}

	loadingDirection(direction: 'FORWARD' | 'BACKWARD') {
		return this.src.loadingDirection === direction;
	}
}